import apiClient from "@/services/ApiClient"

export function comparadorActions(serviceName) {
  return {
    getListComparadorItems(planificacio_id) {
      return apiClient.get(`/${serviceName}/${planificacio_id}/list-comparador`)
    },
    copyItemsToPending(planificacio_id, items) {
      return apiClient.post(`${serviceName}/${planificacio_id}/copy-to-pending`, {
          items: items,
        }
      )
    },
  }
}
